import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/HeaderFooter/Footer';
import '../styles/ResetEmailConfirmation.css';

const ResetEmailConfirmation = () => {
  const navigate = useNavigate();

  // Function to handle the Login button click
  const handleLoginClick = () => {
    navigate('/login'); // Navigate to the login screen
  };

  return (
    <div className="resetconfirmation">
      <div className="content-wrapper">
        
        <div className="logo">    
          <img src="/images/logo.png" alt="Caliber Logo" />
        </div>

        <div className="resetconfirmation-card">
          
          <h1 className="check">Check Your Email
          <img src="/images/verified.png" alt="Verify Icon" className="verify" />
          </h1>
          <p className="subtitle"> Please check your email. We have sent you a link to reset your password. </p>

          <div className="button-align">
            <button className="loginback-btn" onClick={handleLoginClick}> Login </button>
          </div>
          
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ResetEmailConfirmation;
